define('Components/AboutNavByDesireWidget/js/views/DesktopModalView',[
    'jquery',
    'WidgetInstanceView',
    'app',
    'template!Components/AboutNavByDesireWidget/templates/desktop-modal',
    'ProductBlockView',
    'InternalLinkView'
],
    function($,
             WidgetInstanceView,
             app,
             templateDesktopModal,
             ProductBlockView,
             InternalLinkView){
        return WidgetInstanceView.extend({
            name: 'AboutNavByDesireDesktopModalView',
            className:'ANBDW__desktop-modal',
            events: {
                'click .close':'close',
            },
            getTemplate:function(){
                return templateDesktopModal;
            },
            close:function(){
                this.trigger('close',this);
            },
            afterRender:function(){
                var view = this;
                var products = ProductBlockView.initializeProductBlocksOfView(view);
                console.log('products',products);
            }
        })
    }
);
